module.exports = __webpack_public_path__ + "static/media/55_000070.8935de16.jpg";